module.exports = __webpack_public_path__ + "files/a71d6c1c113e490b2aa90c85b17e16c3.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-6.png
// module id = 505
// module chunks = 76